import { ColumnDef } from "@tanstack/react-table";

export type SofaModule = {
  id: string;
  code: string;
  name: string;
  form_price_fabric_category: Array<{
    price: number;
    fabric_price_category: {
      group_number: string;
    };
  }>;
};

export const columns: ColumnDef<SofaModule>[] = [
  {
    accessorKey: "code",
    header: () => "Code",
  },
  {
    accessorKey: "name",
    header: () => "Name",
  },
  {
    accessorKey: "cat_1",
    header: () => <div className="text-right">CAT 1</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 1
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_2",
    header: () => <div className="text-right">CAT 2</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 2
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_3",
    header: () => <div className="text-right">CAT 3</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 3
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_4",
    header: () => <div className="text-right">CAT 4</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 4
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_5",
    header: () => <div className="text-right">CAT 5</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 5
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_6",
    header: () => <div className="text-right">CAT 6</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 6
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_7",
    header: () => <div className="text-right">CAT 7</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 7
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_L1",
    header: () => <div className="text-right">L1</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 11
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
  {
    accessorKey: "cat_L2",
    header: () => <div className="text-right">L2</div>,
    cell: ({ row }) => {
      const price =
        row.original.form_price_fabric_category.find(
          (f: any) => f.fabrice_price_category.group_number === 12
        )?.price || "-";
      return <div className="text-right">{price}</div>;
    },
  },
];
